/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Saveerror1Inputs */

const en_onboarding_saveerror1 = /** @type {(inputs: Onboarding_Saveerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please ask the reception for assistance.`)
};

const fr_onboarding_saveerror1 = /** @type {(inputs: Onboarding_Saveerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Veuillez demander l'aide de la réception.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please ask the reception for assistance." |
*
* @param {Onboarding_Saveerror1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const onboarding_saveerror1 = /** @type {((inputs?: Onboarding_Saveerror1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Saveerror1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_saveerror1(inputs)
	return fr_onboarding_saveerror1(inputs)
});
export { onboarding_saveerror1 as "onboarding_saveError" }